<template>
  <div id="pageHeaderWrapper">
    <template v-if="!auth">
      <h1 class="title is-5">{{ page.bundle.name }}</h1>
      <h2 class="subtitle is-7">{{ [page.dossier.name, page.dossier.profile].join(' - ') }}</h2>
      <hr>
    </template>

    <h2 class="title is-3">
      {{ page.name }}

      <button
        v-if="!isPublic"
        class="button is-pulled-right"
        @click="toggleMode()"
      >
        <span class="icon">
          <i class="fa" :class="(mode === 'tree') ? 'fa-grip-horizontal' : 'fa-stream'"></i>
        </span>
      </button>

      <a
        v-if="isAdmin(account)"
        class="button is-pulled-right mr-2"
        @click="$emit('download')"
      >
        <span class="icon">
          <i class="fas fa-download"></i>
        </span>
      </a>
    </h2>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { authMixin } from '@/mixins'

export default {
  name: 'PageHeader',

  mixins: [
    authMixin
  ],

  computed: {
    ...mapGetters({
      mode: 'pages/mode',
      page: 'pages/page',
      auth: 'account/auth',
      account: 'account/account',
      isPublic: 'pages/isPublic'
    })
  },

  methods: {
    toggleMode () {
      this.$store.commit('pages/SWITCH_MODE')
    }
  }
}
</script>

<style scoped>

</style>
